import React from "react";
import {
  makeStyles,
  Dialog,
  Box,
  Typography,
  Button,
  Container,
  Link,
  useTheme,
  useMediaQuery
} from "@material-ui/core";
import logo from "../../assets/images/icons/logo_expanded.svg";
import clsx from "clsx";
import { Link as RouterLink } from "react-router-dom";
import { LANDING_URL } from "../data/constants";

const useStyles = makeStyles(theme => ({
  paper: {
    [theme.breakpoints.down("sm")]: {
      minWidth: 0
    }
  },
  paperNotRegister: {
    backgroundColor: "#f9f9f9"
  },
  closeTextBtn: {
    padding: theme.spacing(1.25, 2),
    marginRight: theme.spacing(-2),
    fontSize: "14px",
    lineHeight: "16px",
    marginBottom: theme.spacing(-0.25)
  },

  img: {
    marginTop: theme.spacing(10),
    width: 160,
    marginLeft: "auto",
    marginRight: "auto",
    "& img": {
      width: "100%"
    }
  },
  contentWrapper: {
    [theme.breakpoints.down("sm")]: {
      marginTop: theme.spacing(7) + "px !important"
    }
  },
  title: {
    fontWeight: 900,
    fontSize: "3rem",
    lineHeight: "3.5rem",
    marginBottom: theme.spacing(3),
    [theme.breakpoints.down("sm")]: {
      fontSize: "40px",
      lineHeight: "47px"
    }
  },
  subtitle: {
    fontSize: "1.5rem",
    lineHeight: "1.75rem",
    marginBottom: theme.spacing(3),
    color: "#939AAA",
    [theme.breakpoints.down("sm")]: {
      fontSize: "20px",
      lineHeight: "23px"
    }
  },
  stepIndicator: {
    display: "flex",
    justifyContent: "center",
    "& span": {
      display: "block",
      margin: theme.spacing(0, 0.625),
      width: theme.spacing(1),
      height: theme.spacing(1),
      borderRadius: theme.spacing(1),
      backgroundColor: "#DDD",
      "&.active": {
        cursor: "pointer",
        backgroundColor: theme.palette.primary.main
      }
    }
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(0, 4)
    },
    [theme.breakpoints.down("xs")]: {
      padding: theme.spacing(0, 2)
    }
  },
  headerWrapper: {
    height: "72px",
    minHeight: "72px",
    borderBottom: "1px solid #ddd",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  headerImg: {
    width: 160,
    display: "block"
  }
}));

export default function FullSreenDialog({
  isPremium,
  currentStep,
  setCurrentStep,
  isRegister,
  ...props
}) {
  const classes = useStyles();

  const theme = useTheme();
  const screenSm = useMediaQuery(theme.breakpoints.down("sm"), {
    noSsr: true
  });

  let subtitle = "";

  // Define current step title
  switch (currentStep) {
    case 0:
      subtitle = "Tell us a bit about yourself.";
      break;
    case 1:
      subtitle = "Tell us about your company.";
      break;
    case 2:
      subtitle = "Enter your payment information and get started!";
      break;
    default:
      break;
  }

  return (
    <Dialog
      fullScreen
      open={true}
      transitionDuration={0}
      classes={{
        paper: clsx(classes.paper, { [classes.paperNotRegister]: !isRegister })
      }}
    >
      {isRegister ? (
        <>
          <Box className={classes.headerWrapper}>
            <Box
              display="flex"
              component={Container}
              fixed
              justifyContent="center"
              className={classes.header}
            >
              <Link href={`${LANDING_URL}`}>
                <img
                  alt="Routetitan"
                  src={logo}
                  className={classes.headerImg}
                />
              </Link>
              <Button
                // color="primary"
                component={RouterLink}
                to="/login"
                className={classes.closeTextBtn}
                color={screenSm ? "primary" : "default"}
              >
                {screenSm ? "Login instead" : "Already have an account? Login"}
              </Button>
            </Box>
          </Box>
        </>
      ) : (
        <Box className={classes.img}>
          <img alt="Routetitan" src={logo} />
        </Box>
      )}
      {isPremium && (
        <>
          {/* Premium registration (no trial) header */}
          <Box textAlign={"center"} mt={8} px={4}>
            <Typography className={classes.title}>
              Start using Routetitan today
            </Typography>
            <Typography className={classes.subtitle}>{subtitle}</Typography>
            <Box className={classes.stepIndicator}>
              <span
                className={currentStep >= 0 ? "active" : ""}
                onClick={() => (currentStep >= 0 ? setCurrentStep(0) : {})}
              ></span>
              <span
                className={currentStep >= 1 ? "active" : ""}
                onClick={() => (currentStep >= 1 ? setCurrentStep(1) : {})}
              ></span>
              <span
                className={currentStep >= 2 ? "active" : ""}
                onClick={() => (currentStep >= 2 ? setCurrentStep(2) : {})}
              ></span>
            </Box>
          </Box>
        </>
      )}
      <Box
        width="100%"
        height="100%"
        display="flex"
        justifyContent="center"
        alignItems="flex-start"
        style={{ boxSizing: "border-box" }}
        px={4}
        className={clsx({ [classes.contentWrapper]: isRegister })}
        mt={isPremium ? 6 : isRegister ? 15 : 7.5}
      >
        {props.children}
      </Box>
    </Dialog>
  );
}
